import { LOAD_WISHLIST, ADD_TO_WISHLIST, REMOVE_FROM_WISHLIST } from "./types";
import { loadFromStorage, saveToStorage } from "../../storage";

export const loadWishlist = () => (dispatch) => {
  const items = loadFromStorage("wishlist");
  dispatch({ type: LOAD_WISHLIST, payload: items });
};

export const addToWishlist = (movie) => (dispatch, getState) => {
  const data = {
    imdbID: movie.imdbID,
    Title: movie.Title,
    Year: movie.Year,
    Poster: movie.Poster,
    Type: movie.Type,
    addedAt: Date.now(),
  };
  dispatch({ type: ADD_TO_WISHLIST, payload: data });

  setTimeout(() => {
    saveToStorage("wishlist", getState().wishlist.items);
  }, 0);
};

export const removeFromWishlist = (imdbID) => (dispatch, getState) => {
  dispatch({ type: REMOVE_FROM_WISHLIST, payload: imdbID });

  setTimeout(() => {
    saveToStorage("wishlist", getState().wishlist.items);
  }, 0);
};
